import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./LoginPage";
import HomePage from "./HomePage";
import { AuthApi, ApiClient } from "./tradingApiSdk/src";
import { applyMode, Mode } from '@cloudscape-design/global-styles';

// Helper function to detect API URL based on environment
function detectApiBaseUrl() {
  const hostname = window.location.hostname;
  if (hostname.includes("beta")) {
    return "https://beta-api.edge.a1ultra.com";
  } else if (hostname.includes("127.0.0.1")) {
    return "http://127.0.0.1:5000";
  } else {
    return "https://bpgsxuj2jcm33m5w3p55sbfrtm0sitcn.lambda-url.ap-south-1.on.aws";
  }
}

export default function App() {
  const [loggedIn, setLoggedIn] = useState(null);
  const [colorMode, setColorMode] = useState(() => {
    // Get saved preference or default to light
    const savedMode = localStorage.getItem('a1ultra-color-mode');
    return savedMode === 'dark' ? 'dark' : 'light';
  });

  // Apply the color mode
  useEffect(() => {
    applyMode(colorMode === 'dark' ? Mode.Dark : Mode.Light);
    localStorage.setItem('a1ultra-color-mode', colorMode);
  }, [colorMode]);

  // Check authentication status on load
  useEffect(() => {
    async function checkStatus() {
      try {
        const client = new ApiClient();
        client.basePath = detectApiBaseUrl();
        client.enableCookies = true;
        client.fetchOptions = { credentials: "include", cache: "no-cache" };

        const res = await fetch(`${client.basePath}/auth/status`, {
          credentials: "include",
          cache: "no-cache",
        });
        const data = await res.json();

        setLoggedIn(data.logged_in);
      } catch (err) {
        console.error("Status check error:", err);
        setLoggedIn(false);
      }
    }
    checkStatus();
  }, []);

  // Handle mode toggle
  const toggleColorMode = () => {
    setColorMode(prev => prev === 'light' ? 'dark' : 'light');
  };

  // Show loading state while checking authentication
  if (loggedIn === null) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh', 
        backgroundColor: colorMode === 'dark' ? '#0f1b2a' : '#f8f8f8' 
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="loader" style={{ 
            border: '16px solid #f3f3f3',
            borderTop: '16px solid #3498db',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 2s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ 
            color: colorMode === 'dark' ? '#ffffff' : '#000000',
            fontFamily: 'Arial, sans-serif'
          }}>Loading A1Ultra Trading Edge...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={loggedIn ? 
            <Navigate to="/" replace /> : 
            <LoginPage onLoginSuccess={() => setLoggedIn(true)} colorMode={colorMode} />
          } 
        />
        <Route 
          path="/" 
          element={loggedIn ? 
            <HomePage 
              onLogout={() => setLoggedIn(false)} 
              colorMode={colorMode}
              onToggleColorMode={toggleColorMode}
            /> : 
            <Navigate to="/login" replace />
          } 
        />
      </Routes>
    </Router>
  );
}